import React from "react";
import { Tabs } from "antd";
import type { TabsProps } from "antd";

type AppTabsProps = {
  items: TabsProps["items"];              // 탭 구성 데이터
  activeKey?: string;              // 처음 선택될 탭
  onChange?: (key: string) => void;       // 탭 바뀔 때 콜백
  className?: string;                     // 스타일용 클래스
};

const AppTabs: React.FC<AppTabsProps> = ({
  items,
  activeKey,
  onChange,
  className,
}) => {
  return (
    <Tabs
      items={items}
      activeKey={activeKey}
      onChange={onChange}
      className={`tab-type1 ${className ?? ""}`}
    />
  );
};

export default AppTabs;
